import UploadFileInput from './UploadFileInput'

export default UploadFileInput
